import initTransactionApp from '~/javascripts/purchase/init_transaction';
import initNewEESubscriptionApp from '~/javascripts/subscription/init_new_ee_subscription';
import initNewGitLabSubscriptionApp from '~/javascripts/subscription/init_new_gitlab_subscription';
import initDuoProTransactionApp from '~/javascripts/purchase/init_duo_pro_transaction';

document.addEventListener('DOMContentLoaded', () => {
  initDuoProTransactionApp();
  initTransactionApp();
  initNewEESubscriptionApp();
  initNewGitLabSubscriptionApp();
});
